import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import CreateQuizSection from './create_quiz/CreateQuizSection';
import ManageQuizSection from './manage_quiz/ManageQuizSection';
import QuizsummarySection from './quiz_summary/QuizsummarySection';
import './_quiz.scss';

const TILES = [
    {
        key: 'createExam',
        label: 'Create Quiz',
        icon: 'fal fa-plus-circle',
        description: 'For a given topic / topics in a subject create 15 Mins or 30 Mins Quiz, publish the quiz to selected sections in a class.',
    },
    {
        key: 'scheduledQuiz',
        label: 'Manage Quiz',
        icon: 'fal fa-tasks',
        description: 'Already Created Draft, Scheduled, Live Exams Management. Draft Exams can be scheduled.',
    },
    {
        key: 'quizSummary',
        label: 'Quiz Summary',
        icon: 'fal fa-chart-bar',
        description: 'Already completed quiz summary for each quiz wise.',
    },
];

class QuizHomeSection extends Component {
    constructor(props) {
        super(props);
        this.state = { blockType: 'createExam' };
    }

    handleSelect = (val) => this.setState({ blockType: val });

    render() {
        const { blockType } = this.state;

        return (
            <section className="quiz_section">
                <div style={{ background: 'linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)', minHeight: '100vh', padding: '24px 28px', marginBottom: 100 }}>
                    <Container fluid className="px-0">

                        {/* ── Folder-style tabs ── */}
                        <div style={{ background: '#f8fafc', border: '1.5px solid #e2e8f0', borderRadius: 12, padding: '12px 16px 0 16px', marginBottom: 20 }}>
                            <ul className="nav nav-tabs" style={{ borderBottom: 'none', gap: 8 }}>
                                {TILES.map(tile => {
                                    const isActive = blockType === tile.key;
                                    return (
                                        <li className="nav-item" key={tile.key}>
                                            <a
                                                className={`nav-link ${isActive ? 'active' : ''}`}
                                                href="#"
                                                onClick={(e) => { e.preventDefault(); this.handleSelect(tile.key); }}
                                                style={{
                                                    cursor: 'pointer',
                                                    fontWeight: 700,
                                                    fontSize: 14,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 8,
                                                    padding: '12px 20px',
                                                    color: isActive ? '#6366f1' : '#4b5563',
                                                    background: isActive ? '#fff' : 'transparent',
                                                    borderColor: isActive ? '#e2e8f0 #e2e8f0 #fff' : 'transparent',
                                                    borderWidth: '1.5px',
                                                    borderBottomWidth: isActive ? '2px' : '1.5px',
                                                    borderRadius: '10px 10px 0 0',
                                                    transition: 'all 0.15s ease',
                                                    marginBottom: '-1.5px',
                                                }}
                                            >
                                                <i className={tile.icon} />
                                                {tile.label}
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>

                        {/* ── Selected section ── */}
                        {blockType === 'createExam' && (
                            <CreateQuizSection globals={this.props.globals} getSections={this.props.getSections} />
                        )}
                        {blockType === 'scheduledQuiz' && (
                            <ManageQuizSection globals={this.props.globals} savedPapers={this.props.savedPapers} scheduledQuiz={this.props.scheduledQuiz} />
                        )}
                        {blockType === 'quizSummary' && (
                            <QuizsummarySection globals={this.props.globals} getQuizCompletedExams={this.props.getQuizCompletedExams} />
                        )}

                    </Container>
                </div>
            </section>
        );
    }
}

export default QuizHomeSection;
